import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"

/**
 * 重複した行の上書き登録確認ダイアログ
 */
export const DuplicatedPrimaryKeysConfirmationModal = (props: {
	/** 表示可否 */
	isOpen: boolean
	/** 閉じる処理 (true:確定する/false:キャンセル) */
	onClose: (result: boolean) => void
	/** primary keyのフィールド名 */
	primaryKeyName: string
}) => {
	return (
		<Dialog open={props.isOpen} onClose={() => props.onClose(false)} aria-label="upload modal">
			<DialogTitle>重複した行の上書き登録</DialogTitle>
			<DialogContent>
				{props.primaryKeyName}が重複した行が登録されています。
				<br />
				確定すると新しく登録された行で上書きされます。
			</DialogContent>
			<DialogActions>
				<Button onClick={() => props.onClose(false)}>キャンセル</Button>
				<Button onClick={() => props.onClose(true)}>確定する</Button>
			</DialogActions>
		</Dialog>
	)
}
